import React, { useState, useEffect, useMemo } from "react";
import { DOMAINREGEX, MODAL_SIZE } from "../../App.config";
import * as utilities from "../../utilities/utils";
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import ReactDOM from "react-dom";
import swal from 'sweetalert';
import moment from "moment";
import SelectedDomainUserModal from "../../containers/SelectedDomainUserModal";

const DomainList = (props) => {
  const [customeError, setCustomeError] = useState({});
  const [index, setIndex] = useState(null);
  const { register, control, handleSubmit, reset, watch, setValue, getValues, formState: { errors } } = useForm({
    defaultValues: {
      domainList: useMemo(() => {
        return props.domainList
      }, [props])
    }
  });

  const {
    fields,
    append,
    prepend,
    remove,
    swap,
    move,
    insert,
    replace
  } = useFieldArray({
    control,
    name: "domainList"
  });

  useEffect(() => {
    if(props.confirmationValue){
      props.resetConfirmationValue(false,false);
      swal({
        title: "Are you sure?",
        // text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            remove(index);
            swal("Once you submit selected domain will delete successfully", {
              icon: "success",
            });
          } else {
            swal("Domain not deleted");
          }
        })
    }
    if(props.isSelectedUserLoaded){
      props.resetConfirmationValue(false,false);
      props.closeRemoveModal();
      props.openSetModal(<SelectedDomainUserModal {...props}/>,MODAL_SIZE.MODAL_MD);
    }    
  },[props.confirmationValue,props.isSelectedUserLoaded]);

  const onChange = (indexForField, e) => {
    setCustomeError({});
  }

  const handleSubmitData = (data) => {
    let flag = true;
    data.domainList.map((item, index) => {
      for (var i = 0; i < index; i++) {
        if (item.domainURL == data.domainList[i].domainURL) {
          flag = false;
          var customeError1 = customeError;
          customeError1[index.toString()] = "Please change domain name because same domain value can not be accepted!";
          setCustomeError(customeError1);
        }
      }

    })
    if (flag) {
      setCustomeError({});
      props.handleSubmit(data)
    }
  }

  const onDomainDelete = (_index,selectedDomain) => {
    setIndex(_index);
    props.onDomainDelete(selectedDomain);
  }

  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => props.closeRemoveModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <span>
              <ul>
                <li className="">
                  <div className="list-group">
                    <>
                      <form onSubmit={handleSubmit(handleSubmitData)}>
                        <ul>
                          <div className="help-tip mt-1" role="tooltip" id="name-tooltip">
                            <div className="help-tip__content">
                              <h3 className="help-tip__title">example</h3>
                              <p className="help-tip__text">if it is johndoe@oncidium.ca please enter oncidium.ca in list below.</p>
                            </div>
                          </div>
                          {fields ? fields.map((item, index) => {
                            return (
                              <>
                                <li key={item.id}>
                                  <input type="hidden" {...register(`domainList.${index}.whitelistDomainId`)} />
                                  <input type="hidden" {...register(`domainList.${index}.companyId`)} />
                                  <div className="form-row domain-url">
                                    <div className="form-group col-md-7">
                                      <label>Domain Url
                                        <span size="5" className="error-star">
                                          *
                                        </span>
                                      </label>
                                      <Controller
                                        render={({ field }) => <input disabled={item.isDeleted ? true : false} className="form-control" name={index.toString()} {...field} {...register(`domainList.${index}.domainURL`, { required: true, pattern: DOMAINREGEX, onChange: (e) => onChange(index, e) })} />}
                                        name={`domainList.${index}.domainURL`}
                                        control={control}
                                      />
                                      <small className="text-danger">{errors.domainList && errors.domainList[index] && errors.domainList[index]?.domainURL.type === 'required' && "required"}</small>
                                      <small className="text-danger">{errors.domainList && errors.domainList[index] && errors.domainList[index]?.domainURL.type === 'pattern' && "Invalid Domain"}</small>
                                      <small className="text-danger">{customeError && customeError[index] ? customeError[index] : ""}</small>
                                    </div>
                                    <div className="btn-groups">
                                      <div className="float-right pt-4">
                                        {!item.isDeleted ? <button className="btn-primary table-button delete mt-30" type="button" onClick={() => { onDomainDelete(index,item) }}>
                                          Delete
                                        </button> :
                                          <>
                                            <div className="text-danger" >
                                              No Longer Avaliable
                                            </div>
                                            <small><strong>From</strong> {moment(item.createdOnDate).format("DD-MMM-yyyy")} <strong>To</strong> {moment(item.updatedOnDate).format("DD-MMM-yyyy")}</small>
                                          </>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </>
                            );
                          }) : null
                          }
                        </ul>
                        <section>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              append({
                                "whitelistDomainId": null,
                                "companyId": props.selectedCompany,
                                "domainURL": ""
                              });
                            }}
                          >
                            append
                          </button>
                        </section>
                        <input type="submit" className="btn btn-primary float-right" />
                      </form>
                    </>
                  </div>
                </li>
              </ul>
            </span>
          </div>
        </div >
      </div >
    </>
  );
};
export default DomainList;
